import { ParsedUrlQueryInput } from 'querystring'

import { useCallback } from 'react'
import { useParams } from 'next/navigation'
import { useRouter } from 'next/router'
import { Url } from 'next/dist/shared/lib/router/router'

import getStringRouteParam from '../../app/utils/getStringRouteParam'
import { AppRoutes } from '../../app/constants'
import { GiftCardPurchaseMode } from '../types'

type NavigationOptions = {
  /**
   * Set the outlet slug explicitly.
   * Default slug is taken from the router params if exists.
   */
  outletSlug?: string

  /**
   * Specify the purchase mode
   * @default internal
   */
  purchaseMode?: GiftCardPurchaseMode

  /** Replace the route instead of pushing to the history stack */
  replace?: boolean

  /** Shallow routing */
  shallow?: boolean
}

export default function useNavigateGiftCardPurchase() {
  const router = useRouter()

  const routerParams = useParams()

  const handleNavigation = useCallback(
    (options?: NavigationOptions) => {
      const outletSlugParam = getStringRouteParam(routerParams, 'outletSlug')

      const outletSlug = options?.outletSlug || outletSlugParam
      const purchaseMode =
        options?.purchaseMode ?? GiftCardPurchaseMode.Internal
      const replace = !!options?.replace
      const shallow = !!options?.shallow

      if (outletSlug) {
        const query: ParsedUrlQueryInput = {
          outletSlug,
        }

        if (purchaseMode === GiftCardPurchaseMode.Internal) {
          query[purchaseMode] = true
        }

        const url: Url = {
          pathname: AppRoutes.GiftCardPurchase,
          query,
        }

        if (replace) {
          router.replace(url, undefined, {
            shallow,
          })
        } else {
          router.push(url, undefined, {
            shallow,
          })
        }
      }
    },
    [router, routerParams],
  )

  return handleNavigation
}
